module.exports = {"510503001":"安富街道","510503002":"永宁街道","510503003":"东升街道","510503100":"大渡口镇","510503101":"护国镇","510503102":"打古镇","510503103":"上马镇","510503104":"合面镇","510503105":"棉花坡镇","510503106":"丰乐镇","510503107":"白节镇","510503108":"天仙镇","510503109":"新乐镇","510503110":"渠坝镇","510503111":"龙车镇","510503400":"泸州化工园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510503.json
// module id = 2287
// module chunks = 0